
export class Draggable {
    constructor(elem) {
        this.pos = { top: 0,
            left: 0,
            x: 0,
            y: 0 };
        this.elem = elem;

        this.boundMouseDownHandler = this.mouseDownHandler.bind(this);
        this.boundMouseUpHandler = this.mouseUpHandler.bind(this);
        this.boundMouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.elem.addEventListener('mousedown', this.boundMouseDownHandler);
    }

    mouseDownHandler(e) {
        e.preventDefault();
        this.pos = {
            left: this.elem.scrollLeft,
            top: this.elem.scrollTop,
            x: e.clientX,
            y: e.clientY,
        };

        document.addEventListener('mousemove', this.boundMouseMoveHandler);
        document.addEventListener('mouseup', this.boundMouseUpHandler);
    }

    mouseUpHandler() {
        document.removeEventListener('mousemove', this.boundMouseMoveHandler);
        document.removeEventListener('mouseup', this.boundMouseUpHandler);
    }

    mouseMoveHandler(e) {
        const dx = e.clientX - this.pos.x;
        const dy = e.clientY - this.pos.y;

        this.elem.scrollTop = this.pos.top - dy;
        this.elem.scrollLeft = this.pos.left - dx;
    }
}